import { render, staticRenderFns } from "./educationPages.vue?vue&type=template&id=08b06fda&scoped=true"
import script from "./educationPages.vue?vue&type=script&lang=js"
export * from "./educationPages.vue?vue&type=script&lang=js"
import style0 from "./educationPages.vue?vue&type=style&index=0&id=08b06fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b06fda",
  null
  
)

export default component.exports